<template>
  <section class="page-panel">
    <header class="page-panel__header"><h3 class="panel-title">Podaci o vozilu</h3></header>
    <div class="page-panel__content grid-stack grid-row-gap-18">
      <template v-if="!readonly">
        <AppSelect
          :model-value="vehicleId"
          :items="vehicles"
          label="Registarska oznaka"
          placeholder="Odaberite vozilo"
          no-data-text="Nema pronađenih vozila."
          :error-messages="vehicleError"
          searchable
          required
          @update:model-value="$emit('update:vehicleId', $event)"
        >
          <template #selection="{ item }">{{ item.raw.plate }}</template>
        </AppSelect>
        <div class="grid grid-column-gap-16 grid-row-gap-18">
          <div class="col-12 col-sm-6"><AppTextField :model-value="brand" label="Marka" readonly /></div>
          <div class="col-12 col-sm-6"><AppTextField :model-value="vehicle?.name ?? ''" label="Tip" readonly /></div>
          <div class="col-12 col-sm-6"><AppTextField :model-value="vehicle?.vin ?? ''" label="Broj šasije" readonly /></div>
          <div class="col-12 col-sm-6"><AppTextField :model-value="vehicle?.color ?? ''" label="Boja" readonly /></div>
        </div>
      </template>
      <div v-else class="grid grid-column-gap-16 grid-row-gap-18">
        <div class="col-12"><RecordReadOnlyField label="Registarska oznaka" :value="vehicle?.plate" required /></div>
        <div class="col-12 col-sm-6"><RecordReadOnlyField label="Marka" :value="brand" /></div>
        <div class="col-12 col-sm-6"><RecordReadOnlyField label="Tip" :value="vehicle?.name" /></div>
        <div class="col-12 col-sm-6"><RecordReadOnlyField label="Broj šasije" :value="vehicle?.vin" /></div>
        <div class="col-12 col-sm-6"><RecordReadOnlyField label="Boja" :value="vehicle?.color" /></div>
      </div>
      <p class="notice">Vozilo je osigurano za slučaj krađe samo na području RH i EU. Putovanje u inozemstvo dopušteno je isključivo uz pismeno odobrenje vlasnika vozila.</p>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

import { getEventBrandName } from '../../helpers'
import AppSelect from '../AppSelect.vue'
import AppTextField from '../AppTextField.vue'
import RecordReadOnlyField from './RecordReadOnlyField.vue'

const props = defineProps({
  vehicleId: { type: String, default: null },
  vehicle: { type: Object, default: null },
  vehicles: { type: Array, default: () => [] },
  vehicleError: { type: String, default: '' },
  readonly: { type: Boolean, default: false },
})

defineEmits(['update:vehicleId'])

const brand = computed(() => props.vehicle ? getEventBrandName(props.vehicle.brandCode) : '')
</script>
